export default "__VITE_ASSET__B0cTz1OC__"